module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-caution-67b5cfef9a2c70014675a77e37214626.png";